// extracted by mini-css-extract-plugin
export default {"banner":"styles_banner__sOc0p","title":"styles_title__5e4nD","logo":"styles_logo__ATqYw","description":"styles_description__ZgICo","fullWidth":"styles_fullWidth__-ZqRQ"};